export default "__VITE_ASSET__BwinBcBF__"